// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1Fc71","header":"ReportDetails_header__3AmAe","title":"ReportDetails_title__1qpkq","left":"ReportDetails_left__3ipzc"};